export default {
    computed: {
        reloadTrigger() {
            return this.$store.state.report.reload;
        }
    },
    watch: {
        reloadTrigger() {
            // Pozovi glavnu metodu za učitavanje podataka
            if (this.findUsers) {
                this.findUsers();
            } else if (this.fetchFoods) {
                this.fetchFoods();
            } else if (this.fetchRestaurantMeals) {
                this.fetchRestaurantMeals();
            } else if (this.fetchTakenReport) {
                this.fetchTakenReport({
                    date: this.filters.dates.from,
                    date2: this.filters.dates.to,
                });
            }
        }
    },
    methods: {
        triggerReload() {
            this.$store.commit('report/SET_RELOAD');
        }
    }
};
